import styled from 'styled-components';
import { Style } from '../../styles';

const ConversationItemContent = styled.div`
	display: flex;
	flex-direction: row;
	padding: ${Style.spacing.x1_5};
`

export default ConversationItemContent